import React, { useState, useEffect, useContext } from 'react';
import api from '../utils/api';
import StudentListPopup from './StudentListPopup';
import PublicStudentListPopup from './PublicStudentListPopup';
import './styles/TransferInventoryPage.css';
import { BsFiles } from "react-icons/bs";
import { useNavigate } from 'react-router-dom'; 
import { generatePaymentReceiptPDF } from './util/paymentReceipt';

const ClassCreatePage = () => {
    const [programList, setProgramList] = useState([]);
    const [costList, setCostList] = useState([]);
    const [program, setProgram] = useState('');
    const [receiver, setReceiver] = useState(null);
    const [showStudentPopup, setShowStudentPopup] = useState(false);
    const [showPublicStudentPopup, setShowPublicStudentPopup] = useState(false);
    const [studentType, setStudentType] = useState('STUDENT');
    const [classDate, setClassDate] = useState('');
    const [paymentDate, setPaymentDate] = useState('');
    const [paymentAmount, setPaymentAmount] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        api.get('/utils/getProgramClassList')
          .then(response => setProgramList(response.data.data.programList))
          .catch(error => console.error('Error fetching program list:', error));

        api.get('/utils/getCostClassList')
          .then(response => setCostList(response.data.data.costList))
          .catch(error => console.error('Error fetching program list:', error));

          
    }, []);
    
    const handleProgramChange = (programId) => {
        const cost = costList.find(cost => cost.program_id == programId);
        
        if (cost) {
            setPaymentAmount(cost.cost_amount); // Set payment amount from selected program
        } else {
            setPaymentAmount(0); // Reset if no program is selected
        }

        setProgram(programId);
    };

    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };

    const handleSelectStudent = (student) => {
        setReceiver(student);
        setShowStudentPopup(false);
    };

    const handleSelectPublicStudent = (student) => {
        setReceiver(student);
        setShowPublicStudentPopup(false);
    };

    const handleStudentTypeChange = (e) => {
        setStudentType(e.target.value);
        setReceiver(null); // Set receiver to null
    };const validateForm = () => {
        const errors = {};
    
        // Cek jika field kosong
        
        if (!program) errors.program = 'Program is required';
        if (!paymentMethod) errors.payment_method = 'Payment Method is required';
        if (!classDate) errors.classDate = 'Class Month is required';
        if (!receiver) errors.receiver = 'Student is required';
        if (!paymentDate) errors.paymentDate = 'Payment Date is required';
        if (paymentAmount==0) errors.paymentAmount = 'Payment amount is required';
        if (!description) errors.description = 'Description is required';

        return errors;
    };
   
    const handleSubmit = () => {
        
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            console.log('Validation Errors:', validationErrors);
        } else {
            const confirmation = window.confirm('Are you sure you want to proceed with this action?');
            if (!confirmation) {
                return;
            }
            let classData={};

            if (studentType === 'STUDENT'){
                classData = {
                    data: {
                        classData: {
                            student_type: studentType,
                            student_id: receiver.student_id, 
                            class_date: classDate,
                            program_id: program,
                            payment_amount: paymentAmount,
                            payment_method: paymentMethod,
                            payment_date: paymentDate,
                            description: description
                        },
                    },
                };
            } else {
                classData = {
                    data: {
                        classData: {
                            student_type: studentType,
                            public_student_id: receiver.public_student_id, 
                            class_date: classDate,
                            program_id: program,
                            payment_amount: paymentAmount,
                            payment_method: paymentMethod,
                            payment_date: paymentDate,
                            description: description
                        },
                    },
                };
            }

        
            api.post(`student/class/save`, classData)
            .then(response => {
                const successMessage = response.data.message;
                console.log(successMessage);
                handleGeneratePDF();
                navigate('/success', { state: { message: successMessage } });
                
            })
            .catch(error => {
                console.error('Error adding student:', error);
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
            });
        }
    
        

    };

    const handleGeneratePDF = () => {
        const programObj = programList.find(p => p.program_id == program);
        const programName = programObj ? programObj.program_name : '-';
        const costItem = programObj?.Costs?.[0]?.cost_item || '-';
      
        const classMonthFormatted = new Date(classDate).toLocaleDateString('id-ID', {
          year: 'numeric',
          month: 'long',
        });


        const paymentData = {
            paymentMethod,
        };

        const paymentDetails = [
            {
              item: `${programName} - ${costItem} - ${classMonthFormatted}`,
              amount: paymentAmount,
            }
        ];
      
        generatePaymentReceiptPDF(receiver, paymentData, paymentDetails, paymentDate, 'CLASS');
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Class Program Registration</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Student Data</h3>
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Student Type</label>
                                    </td>
                                    <td>
                                        <select value={studentType} onChange={handleStudentTypeChange}>
                                            <option value="STUDENT">Kidola Student</option>
                                            <option value="PUBLIC">Public Student</option>
                                        </select>
                                    </td>
                                </tr>
                                {studentType === 'STUDENT' &&
                                <tr>
                                    <td>
                                        <label>Student Name</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={receiver ? receiver.student_name : ''} readOnly />
                                            <BsFiles className="icon" onClick={() => setShowStudentPopup(true)} />
                                        </div>
                                    </td>
                                </tr>
                                }
                                {studentType === 'STUDENT' &&
                                <tr>
                                    <td>
                                        <label>Student Code</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={receiver ? receiver.student_code : ''} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                }
                                {studentType === 'PUBLIC' &&
                                <tr>
                                    <td>
                                        <label>Public Student Name</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={receiver ? receiver.student_name : ''} readOnly />
                                            <BsFiles className="icon" onClick={() => setShowPublicStudentPopup(true)} />
                                        </div>
                                    </td>
                                </tr>
                                }
                                <tr>
                                    {errors.receiver && 
                                    <td>
                                        <div className="error-message">{errors.receiver}</div>
                                    </td>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                </div>
                <div className="section">
                    <h3 className="section-header">Class Data</h3>
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Class Month</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="month"
                                            name="classDate"
                                            value={classDate} 
                                            onChange={e => setClassDate(e.target.value)}
                                        />
                                    </td>  
                                </tr>
                                <tr>
                                    {errors.classDate && 
                                    <td>
                                        <div className="error-message">{errors.classDate}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Program Class</label>
                                    </td>
                                    <td>
                                        <select value={program} onChange={(e) => handleProgramChange(e.target.value)}>
                                            <option value="">Select Program</option>
                                            {programList.map(program => (
                                                <option key={program.program_id} value={program.program_id}>
                                                    {program.program_name} - {program.Costs[0].cost_item}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    {errors.program && 
                                    <td>
                                        <div className="error-message">{errors.program}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Payment Amount</label>
                                    </td>
                                    <td>
                                        <input type="number"     value={formatCurrency(paymentAmount)}  onChange={(e) => setPaymentAmount(e.target.value)} readOnly/>
                                    </td>
                                </tr>
                                <tr>
                                    {errors.paymentAmount && 
                                    <td>
                                        <div className="error-message">{errors.paymentAmount}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Payment Date</label>
                                    </td>
                                    <td>
                                        <input type="date" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} />
                                    </td>
                                </tr>
                                <tr>
                                    {errors.paymentDate && 
                                    <td>
                                        <div className="error-message">{errors.paymentDate}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Payment Method</label>
                                    </td>
                                    <td>
                                        <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} >
                                            <option key="" value="">Choose Payment Method</option>
                                            <option key="BANK BCA" value="BANK BCA">BANK BCA</option>
                                            <option key="BANK BRI" value="BANK BRI">BANK BRI</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    {errors.payment_method && 
                                    <td>
                                        <div className="error-message">{errors.payment_method}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Description</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <textarea value={description} onChange={(e) =>setDescription(e.target.value)} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    {errors.description && 
                                    <td>
                                        <div className="error-message">{errors.description}</div>
                                    </td>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="search-container">
                        <button className="profile-button" onClick={handleSubmit}>Submit</button>
                </div>
            </div>
            
            

            {showStudentPopup && (
                <StudentListPopup 
                    onSelectStudent={handleSelectStudent} 
                    onClose={() => setShowStudentPopup(false)} 
                />
            )}
            {showPublicStudentPopup && (
                <PublicStudentListPopup 
                    onSelectStudent={handleSelectPublicStudent} 
                    onClose={() => setShowPublicStudentPopup(false)} 
                />
            )}
        </div>
    );
};

export default ClassCreatePage;
